export default __webpack_public_path__ + "static/media/growth-chart.ea704ca6.svg";